module.exports = __webpack_public_path__ + "static/loader-white-720-12226e390bb4604a1bb02e27163ecc99.gif";